const en = {
  lang_switch_label: 'Language',

  global_empty_state_title: 'Nothing here yet',
  global_empty_state_description: 'Add your first entry to get started.',
  pagination_go_to_page: 'Go to page',
  pagination_items_per_page: 'Items per page',
  pagination_first_page: 'First page',
  pagination_previous_page: 'Previous page',
  pagination_next_page: 'Next page',
  pagination_last_page: 'Last page',

  auth_hero_tagline: 'Upload your invoice. Pay in installments.',

  login_welcome_back: 'Welcome back',
  login_subtitle: 'Sign in with email and password.',
  login_email_label: 'Email',
  login_password_label: 'Password',
  login_button: 'Sign in',
  login_forgot_password: 'Forgot password?',
  login_reset_it: 'Reset',
  login_error_user_not_found: 'Email and password do not match our records.',
  login_error_wrong_password: 'Wrong password.',
  login_error_invalid_email: 'Invalid email address.',
  login_error_user_disabled: 'This account has been disabled.',
  login_error_login_failed: 'Sign-in failed. Please try again.',
  login_unexpected_error: 'Something went wrong. Please try again.',
  login_need_account: 'No account yet?',
  login_go_signup: 'Sign up',

  signup_create_account: 'Create account',
  signup_get_started_description: 'Use the same email you will use in production.',
  signup_display_name_label: 'Display name (optional)',
  signup_email_label: 'Email',
  signup_password_label: 'Password',
  signup_confirm_password_label: 'Confirm password',
  signup_passwords_do_not_match: 'Passwords do not match.',
  signup_button: 'Create account',
  signup_already_have_account: 'Already have an account?',
  signup_login_link: 'Sign in',
  signup_email_already_in_use: 'This email is already registered.',
  signup_weak_password: 'Password is too weak. Use at least 6 characters.',
  signup_unexpected_error: 'Could not create account. Please try again.',
  signup_firestore_hint:
    'Creates a Firestore document under users/{uid}. Ensure security rules allow the signed-in user to write their profile.',

  reset_password_title: 'Reset password',
  reset_password_subtitle: 'We will send a link to choose a new password.',
  reset_password_email_label: 'Email',
  reset_password_send_button: 'Send link',
  reset_password_remembered_password: 'Remembered your password?',
  reset_password_back_to_login: 'Back to sign in',
  reset_password_success_message:
    'If an account exists for this email, you will receive a link shortly.',
  reset_password_error_unauthorized_domain:
    'This domain is not authorized for password reset. Add it under Firebase Console → Authentication → Settings → Authorized domains.',
  reset_password_error_no_account_found: 'No account found for this email.',
  reset_password_error_invalid_email: 'Please enter a valid email address.',
  reset_password_error_link_not_sent: 'Could not send the link. Please try later.',
  reset_password_unexpected_error: 'Something went wrong. Please try again.',
  reset_password_action_url_hint:
    'Set the Firebase Auth Action URL (Continue URL) to /confirm-password on this origin.',

  reset_password_new_password_title: 'Choose a new password',
  reset_password_new_password_subtitle: 'Enter and confirm your new password.',
  reset_password_verifying: 'Checking reset link…',
  reset_password_error_code_invalid: 'This reset link is invalid or already used.',
  reset_password_error_code_expired: 'This reset link has expired. Request a new one.',
  reset_password_new_password_label: 'New password',
  reset_password_confirm_password_label: 'Confirm new password',
  reset_password_reset_button: 'Update password',
  reset_password_success_reset: 'Password updated. Redirecting to sign in…',
  reset_password_error_passwords_mismatch: 'Passwords do not match.',
  reset_password_error_password_too_short: 'Use at least 6 characters.',
  reset_password_error_weak_password: 'Password is too weak. Choose a stronger one.',
  reset_password_error_generic: 'Could not reset password. Please try again.',
  reset_password_request_new_link: 'Request a new reset link',

  nav_home: 'Overview',
  nav_cases: 'Financing cases',
  nav_customers: 'Customers',
  nav_documents: 'Offers & invoices',
  nav_installments: 'Installment options',
  nav_branding: 'Branding',
  nav_audit: 'Audit log',
  nav_settings: 'Settings',
  nav_docs: 'Docs',
  nav_changelog: 'Changelog',
  nav_clients: 'Clients',
  nav_lenders: 'Lenders',
  nav_financing_options: 'Financing options',
  nav_team: 'Team',

  common_save: 'Save',
  common_cancel: 'Cancel',
  common_create: 'Create',
  common_edit: 'Edit',
  common_archive: 'Archive',
  common_error_generic: 'Something went wrong. Please try again.',
  common_loading: 'Loading…',
  common_search: 'Search',
  common_no_results: 'No results.',
  common_status: 'Status',
  common_actions: 'Actions',
  common_back: 'Back',
  common_next: 'Next',
  common_publish: 'Publish',
  common_copy_link: 'Copy link',

  role_client_admin: 'Admin',
  role_client_user: 'Staff',
  role_internal_admin: 'Craftin Admin',
  role_lender_admin: 'Lender Admin',
  topbar_your_role: 'Your role',

  create_org_title: 'Set up your company',
  create_org_subtitle:
    'A company is your Craftin workspace: customers, documents, and financing cases live here.',
  create_org_name_label: 'Company name',
  create_org_legal_name_label: 'Legal name',
  create_org_submit: 'Create company',
  create_org_error: 'Could not create the company. Please try again.',
  create_org_or: 'Or create a new company:',
  invites_title: 'You have been invited',
  invites_role_label: 'Role',
  invites_accept: 'Accept',
  invites_decline: 'Decline',
  invites_error: 'Could not process the invitation. Please try again.',

  home_title: 'Company overview',
  home_cases_open: 'Open cases',
  home_cases_submitted: 'Submitted',
  home_volume: 'Financed volume (approved)',
  home_customers: 'Customers',
  home_docs_review: 'Documents needing review',
  home_expiring: 'Expiring soon',
  home_cta_case: 'New financing case',
  home_cta_document: 'Upload document',
  home_empty: 'Create a customer and upload an invoice to start your first financing case.',

  customers_title: 'Customers',
  customers_add: 'Add customer',
  customers_col_name: 'Name',
  customers_col_email: 'Email',
  customers_col_type: 'Type',
  customers_col_status: 'Status',
  customers_empty: 'No customers yet. Add the homeowner or business you are financing for.',
  customer_form_create: 'New customer',
  customer_form_edit: 'Edit customer',
  customer_type_consumer: 'Consumer',
  customer_type_business: 'Business',
  customer_first_name: 'First name',
  customer_last_name: 'Last name',
  customer_business_name: 'Business name',
  customer_email: 'Email',
  customer_phone: 'Phone',
  customer_city: 'City',
  customer_duplicate_warn: 'A customer with this email already exists in your company.',

  documents_title: 'Offers & invoices',
  documents_add: 'New document',
  documents_upload: 'Upload & extract',
  documents_col_number: 'Number',
  documents_col_type: 'Type',
  documents_col_customer: 'Customer',
  documents_col_total: 'Total',
  documents_col_extraction: 'Extraction',
  documents_col_status: 'Status',
  documents_empty: 'Upload a quote or invoice, or create one manually.',
  document_form_create: 'Create document',
  document_form_edit: 'Review document',
  document_type_quote: 'Quote',
  document_type_invoice: 'Invoice',
  document_number: 'Document number',
  document_issue_date: 'Issue date',
  document_total_gross: 'Gross total',
  document_confirm: 'Confirm extraction',
  document_extract: 'Run extraction',
  document_line_desc: 'Description',
  document_needs_customer: 'Select a customer first',

  cases_title: 'Financing cases',
  cases_add: 'New case',
  cases_col_number: 'Case',
  cases_col_customer: 'Customer',
  cases_col_amount: 'Amount',
  cases_col_status: 'Status',
  cases_col_expires: 'Expires',
  cases_empty: 'No financing cases yet. Start from a reviewed document.',
  case_wizard_title: 'Create financing case',
  case_wizard_step_customer: 'Customer',
  case_wizard_step_document: 'Document',
  case_wizard_step_financing: 'Financing',
  case_wizard_step_publish: 'Publish',
  case_wizard_amount: 'Financed amount',
  case_wizard_plans: 'Available installment options',
  case_wizard_expires_days: 'Link expires in (days)',
  case_wizard_title_field: 'Customer-facing title',
  case_publish_success: 'Case published. Share the checkout link with your customer.',
  case_link_copied: 'Link copied',

  installments_title: 'Installment options',
  installments_empty: 'No active installment options. Ask Craftin to enable products for your company.',
  installments_col_name: 'Product',
  installments_col_term: 'Term',
  installments_col_rate: 'Nominal rate',
  installments_col_range: 'Amount range',
  installments_col_status: 'Status',
  installments_months: '{n} months',

  branding_title: 'Branding',
  branding_primary: 'Primary color',
  branding_secondary: 'Secondary color',
  branding_support_email: 'Support email',
  branding_support_phone: 'Support phone',
  branding_privacy: 'Privacy policy URL',
  branding_terms: 'Terms URL',
  branding_preview: 'Checkout preview',
  branding_saved: 'Branding saved',
  branding_logo: 'Logo',
  branding_hero_image: 'Hero image',
  branding_upload_hint: 'PNG, JPG or SVG — max. 2 MB',
  branding_file_too_large: 'Please use an image up to 2 MB.',
  branding_whitelabel_title: 'White-label financing check',
  branding_whitelabel_hint:
    'Share this link to let your customers run the financing check in your branding.',

  audit_title: 'Audit log',
  audit_empty: 'No audit events yet.',
  audit_col_when: 'When',
  audit_col_actor: 'Actor',
  audit_col_action: 'Action',
  audit_col_object: 'Object',

  settings_title: 'Company settings',
  settings_company: 'Company profile',
  settings_members: 'Team',
  settings_invite: 'Invite user',
  settings_invite_email: 'Email',
  settings_invite_role: 'Role',
  settings_legal_name: 'Legal name',
  settings_email: 'Company email',
  settings_city: 'City',
  settings_street: 'Street',
  settings_house_number: 'No.',
  settings_postal: 'Postal code',

  team_title: 'Team',
  team_col_name: 'Name',
  team_col_email: 'Email',
  team_col_role: 'Role',
  team_col_org: 'Organization',
  team_filter_role: 'Role',
  team_filter_all: 'All roles',
  team_empty: 'No users found.',
  team_invite: 'Invite user',
  team_invite_hint: 'The invitation email contains a personal link to join {org}.',
  team_invite_org: 'Organization',
  team_invite_org_placeholder: 'Select organization',
  team_invite_success: 'Invitation sent to {email}.',
  team_invite_error_member: 'This email already belongs to a member of the organization.',
  team_invite_copy_link: 'Copy invitation link',
  team_invite_link_copied: 'Link copied',
  team_invite_done: 'Done',
  team_pending_title: 'Pending invitations',

  invite_verifying: 'Checking invitation…',
  invite_title: 'You have been invited',
  invite_intro: '{inviter} invited you to join {org} on Craftin.',
  invite_invalid: 'This invitation link is invalid or no longer available.',
  invite_expired: 'This invitation has expired. Please ask for a new one.',
  invite_already_accepted: 'This invitation has already been accepted.',
  invite_declined_done: 'You have declined the invitation.',
  invite_mismatch:
    'This invitation was sent to {email}. Please sign out and continue with that address.',
  invite_sign_out: 'Sign out',
  invite_accept_and_join: 'Create account & join',
  invite_have_account: 'Already have an account?',
  invite_sign_in: 'Sign in',
  invite_accept_error: 'Could not process the invitation. Please try again.',
  invite_already_member_error: 'Your account already belongs to another company workspace.',
  invite_go_home: 'Go to my workspace',
  invite_go_login: 'Go to sign in',

  clients_title: 'Clients',
  clients_add: 'Add client',
  clients_empty: 'No client companies yet.',
  clients_col_name: 'Company',
  clients_col_city: 'City',
  clients_col_email: 'Email',
  clients_col_status: 'Status',
  clients_form_create: 'New client',
  clients_form_edit: 'Edit client',
  clients_legal_form: 'Legal form',

  lenders_title: 'Lenders',
  lenders_add: 'Add lender',
  lenders_empty: 'No lenders yet.',
  lenders_col_name: 'Name',
  lenders_col_integration: 'Integration',
  lenders_col_status: 'Status',
  lenders_form_create: 'New lender',
  lenders_form_edit: 'Edit lender',
  lenders_customer_types: 'Customer types',
  lenders_customer_both: 'Consumer & business',
  lenders_deactivate: 'Deactivate',

  financing_options_title: 'Financing options',
  financing_options_add: 'Add option',
  financing_options_empty: 'No financing options yet.',
  financing_options_col_lender: 'Lender',
  financing_options_form_create: 'New financing option',
  financing_options_form_edit: 'Edit financing option',
  financing_options_scope: 'Scope',
  financing_options_scope_global: 'Global',
  financing_options_scope_company: 'Company',
  financing_options_term_months: 'Term (months)',
  financing_options_rate_bps: 'Nominal rate (bps)',
  financing_options_min_amount: 'Min amount (EUR)',
  financing_options_max_amount: 'Max amount (EUR)',

  checkout_loading: 'Loading checkout…',
  checkout_invalid: 'This financing link is invalid or no longer available.',
  checkout_expired: 'This financing link has expired.',
  checkout_revoked: 'This financing link was revoked.',
  checkout_welcome: 'Finance your project',
  checkout_review_doc: 'Your offer',
  checkout_select_plan: 'Choose a payment plan',
  checkout_your_details: 'Your details',
  checkout_consent:
    'I agree that Craftin and the financing partner may process my data to assess this financing application (credit check). Details are in the privacy notice.',
  checkout_submit: 'Submit application',
  checkout_monthly: 'Monthly',
  checkout_total: 'Total payable',
  checkout_term: 'Term',
  checkout_result_approved: 'Approved',
  checkout_result_rejected: 'Not approved',
  checkout_result_pending: 'Under review',
  checkout_result_info: 'Additional information required',
  checkout_result_error: 'Technical problem — please contact the craftsman company.',
  checkout_secure: 'Secure connection',
  checkout_powered: 'Financing checkout by Craftin',

  check_title: 'Finance your invoice',
  check_subtitle: 'Upload your craftsman invoice or enter the amount, we check whether we can arrange installment financing for you.',
  check_subtitle_branded: 'Upload your invoice from {company} or enter the amount, we check whether we can arrange installment financing for you.',
  check_powered_by: 'Powered by Craftin',
  check_step_1: 'Step 1 of 2 — Your invoice',
  check_step_2: 'Step 2 of 2 — Your account',
  check_mode_upload: 'Upload invoice',
  check_mode_upload_hint: 'PDF or photo',
  check_mode_manual: 'Enter amount',
  check_mode_manual_hint: 'No file at hand',
  check_file_label: 'Invoice',
  check_file_placeholder: 'No file selected',
  check_file_hint: 'PDF, JPG or PNG — max. 20 MB',
  check_file_browse: 'Choose file',
  check_extracting_title: 'Analyzing your invoice …',
  check_extracting_hint: 'Amount and company are read automatically.',
  check_review_title: 'Detected invoice details',
  check_review_provider: 'Company',
  check_review_city: 'City',
  check_review_amount: 'Amount',
  check_review_description: 'Work',
  check_review_hint: 'Detected automatically — please double-check.',
  check_review_edit: 'Correct details',
  check_review_change_file: 'Choose another file',
  check_extract_failed: 'We could not read the invoice automatically. Please enter the details manually.',
  check_extract_incomplete: 'We could not detect all details. Please fill in the missing fields.',
  check_manual_file_attached: 'Invoice attached:',
  check_amount_label: 'Invoice amount (EUR)',
  check_amount_optional_label: 'Invoice amount (EUR, optional)',
  check_provider_label: 'Craft company on the invoice',
  check_provider_placeholder: 'e.g. Müller Sanitär GmbH',
  check_provider_city_label: 'City of the company (optional)',
  check_description_label: 'What was the work? (optional)',
  check_account_title: 'Create your account',
  check_account_subtitle: 'You will track your financing request and its result here.',
  check_signed_in_as: 'Signed in as',
  check_consent: 'I agree that Craftin and its financing partners may process my data and the invoice to check my financing options. Details are in the privacy notice.',
  check_submit: 'Check financing',
  check_error_provider: 'Please enter the craft company from your invoice.',
  check_error_file_required: 'Please choose an invoice file or switch to entering the amount.',
  check_error_file_invalid: 'Please use a PDF, JPG or PNG up to 20 MB.',
  check_error_amount: 'Please enter a valid amount, e.g. 2.500,00.',
  check_error_consent: 'Please accept the data processing consent.',
  check_error_email_in_use: 'This email is already registered.',
  check_error_already_member: 'Your account already belongs to a company workspace. Please sign in and contact support.',
  check_upload_failed: 'Your request was saved, but the invoice upload failed. You can add the invoice later in your account.',
  check_success_title: 'Request received',
  check_success_body: 'We are checking whether we can arrange financing for you. You will see the result in your account.',
  check_success_reference: 'Your reference',
  check_success_cta: 'Go to my account',

  docs_title: 'Documentation',
  changelog_title: 'Changelog',
} as const;

export type MessageKey = keyof typeof en;
export default en;
